import { render, staticRenderFns } from "./ModalBottomLayout.vue?vue&type=template&id=3c7e2cbd&scoped=true&"
import script from "./ModalBottomLayout.vue?vue&type=script&lang=ts&"
export * from "./ModalBottomLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ModalBottomLayout.vue?vue&type=style&index=0&id=3c7e2cbd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7e2cbd",
  null
  
)

export default component.exports